const binding = { modules: {}, dataActions: {} };

    (binding.modules['obs-custom'] = {
        c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/adventureworks'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['business-organization-list','cart-icon','cart','checkout','header','navigation-menu','order-template','search-result-container','search','tile-list-item'],
        iNM: true,
        ns: '__local__',
        n: 'obs-custom',
        p: '__local__',
        
        pdp: 'node_modules/@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/adventureworks.definition.json',
        
        themeSettings: 'obs-custom.theme.settings.json',
        md: 'src/themes/obs-custom'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };